import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  ButtonStyledTb,
  FormButtonStyled,
  FormEleWrapper,
  HeadingStyled,
  LabelStyled,
  SubHeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import { Camera, ProfileImgLarge } from "../../../components/styled/AllImages";
import { Col, Form, Row } from "react-bootstrap";
import { ProfileEditContainer } from "./styled";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import ProfileApi from "../../../services/api/profileApi";
import { toast } from "react-toastify";
import { useUser } from "../../../context/userContext";
import { urlRegex } from "../../../utils";
import { useNavigate } from "react-router-dom";

const WebSocialMedia = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const { fetchUserInfo, user } = useUser();

  const onSubmit = async (formData) => {
    const allEmpty = Object.values(formData).every((value) => value === "");

    if (!allEmpty) {
      try {
        setLoading(true);
        const { code, message } = await ProfileApi.saveSocialMedia(formData);
        if (code === 200) {
          toast.success(t("social_information_updated"));
          fetchUserInfo();
        }
        if (code === 100 || code === 204) {
          toast.error(message);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    } else {
      toast.info(t("fill_atleast_one_field"));
    }
  };

  useEffect(() => {
    if (user) {
      reset({
        website_url: user?.social_media?.website_url,
        facebook_profile_link: user?.social_media?.facebook_profile_link,
        instagram_profile_link: user?.social_media?.instagram_profile_link,
        linkedin_profile_link: user?.social_media?.linkedin_profile_link,
        x_profile_link: user?.social_media?.x_profile_link,
        youtube_channel_link: user?.social_media?.youtube_channel_link,
        one_day_profile_link: user?.social_media?.one_day_profile_link,
      });
    }
  }, [user]);
  return (
    <>
      <ProfileEditContainer>
        <HeadingStyled size="24px" className="editProfileHeading">
          {t("WebSocialMedia")}
        </HeadingStyled>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box className="profileFormContainerInner">
            <Row className="mt-3">
              <Col md={12}>
                <ValidatedInput
                  name="website_url"
                  type="input"
                  fieldType="text"
                  placeholder="WebsiteURL"
                  label="WebsiteURL"
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="facebook_profile_link"
                  type="input"
                  fieldType="text"
                  placeholder="FacebookProfileLink"
                  label="FacebookProfile"
                  className="combined"
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="instagram_profile_link"
                  type="input"
                  fieldType="text"
                  placeholder="InstagramProfileLink"
                  label="InstagramProfileLink"
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="linkedin_profile_link"
                  type="input"
                  fieldType="text"
                  placeholder="LinkedInProfileLink"
                  label="LinkedInProfileLink"
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="x_profile_link"
                  type="input"
                  fieldType="text"
                  placeholder="XProfileLink"
                  label="XProfileLink"
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="youtube_channel_link"
                  type="input"
                  fieldType="text"
                  placeholder="YouTubeChannelLink"
                  label="YouTubeChannelLink"
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
              <Col md={12}>
                <ValidatedInput
                  name="one_day_profile_link"
                  type="input"
                  fieldType="text"
                  placeholder="one_day_profile_link"
                  label="one_day_profile_link"
                  className=""
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: false,
                    pattern: {
                      value: urlRegex,
                      message: t("please_enter_valid_url"),
                    },
                  }}
                />
              </Col>
            </Row>
            <Box className="formBtns">
              <ButtonStyledTb
                className="nextStepBtn"
                type="button"
                bg="var(--white)"
                border="var(--border)"
                color="var(--darkGrey)"
                onClick={() => navigate("/my-profile")}
              >
                {t("Cancel")}
              </ButtonStyledTb>
              <FormButtonStyled
                type="submit"
                bg="var(--themeColorSecondary)"
                disabled={loading}
                isLoading={loading}
                label={t("Update")}
              />
            </Box>
          </Box>
        </Form>
      </ProfileEditContainer>
    </>
  );
};

export default WebSocialMedia;
